import { Button, Mark } from "@mashriqain/ui";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import styles from "./NotFound.module.css";

export default function NotFound() {
  useDocumentMeta("Not found");
  return (
    <section className={styles.page}>
      <Mark size={120} draw className={styles.mark} />
      <p className="eyebrow">404</p>
      <h1 className="display">This path leads beyond the horizon.</h1>
      <p className="lede">The page you are looking for has moved, or was never here.</p>
      <Button to="/">Return home</Button>
    </section>
  );
}
